module.exports = {"id":"202416","name":"Martos","rating":"72","photo":"./data/images/photos/1/202416.png","club":{"name":"Sp. Charleroi","logo":"./data/images/clubs/Sp.Charleroi.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Martos0.json
// module id = 2829
// module chunks = 0